import { format } from "date-fns";
import { es } from "date-fns/locale";
import { TooltipProps } from "recharts";

interface CustomTooltipProps extends TooltipProps<any, any> {
  routineNames?: string[];
  completedRoutines?: string[];
}

export const CustomTooltip = ({ active, payload, label }: CustomTooltipProps) => {
  if (active && payload && payload.length) {
    const dayData = payload[0].payload;
    return (
      <div className="bg-black/90 border border-white/10 rounded-lg p-4 text-sm">
        <p className="font-bold text-white mb-2">{label}</p>
        <div className="space-y-2">
          {dayData.routineNames.length === 0 ? (
            <p className="text-white/60">Día de descanso</p>
          ) : (
            <>
              <div className="flex justify-between items-center">
                <span className="text-white/60">Meta del día:</span>
                <span className="text-clubbers-light-blue font-semibold">{dayData.goal} rutinas</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-white/60">Completadas:</span>
                <span className="text-clubbers-light-blue font-semibold">{dayData.count} rutinas</span>
              </div>
              <div className="mt-3">
                <p className="text-white/60 mb-1">Rutinas asignadas:</p>
                {dayData.routineNames.map((name: string, index: number) => {
                  const isCompleted = dayData.completedRoutines.includes(name);
                  return (
                    <p key={index} className={`flex items-center gap-2 ${isCompleted ? 'text-green-400' : 'text-clubbers-light-blue'}`}>
                      • {name} {isCompleted && '✓'}
                    </p>
                  );
                })}
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
  return null;
};